import { cn } from "ui/lib/utils";
import { ResponsiveSelect } from "apollo/components/mobile/responsive-select";
import { changeEvent } from "./change-event";

const DEFAULT_PLACEHOLDER = "Please Select";

export const Select = ({
  options,
  value,
  onChange,
  placeholder = DEFAULT_PLACEHOLDER,
  className,
  title = "",
  ...props
}) => {
  return (
    <ResponsiveSelect
      title={title || props["aria-label"] || placeholder || "Choose"}
      value={value == null ? "" : String(value)}
      options={options.map(({ value, label }) => ({
        value: String(value),
        label: label || String(value),
      }))}
      placeholder={placeholder || undefined}
      disabled={props.disabled}
      onChange={(next) => onChange?.(changeEvent(next))}
    >
      <select
        onChange={onChange}
        value={value}
        className={cn(
          "flex min-w-[70px] h-9 items-center justify-between rounded-lg border border-white/[0.08] bg-transparent px-3 py-2 text-xs placeholder:text-white/30 focus:outline-none focus:border-white/[0.15] disabled:cursor-not-allowed disabled:opacity-40",
          className
        )}
        // The default placeholder doesn't say what the field is, so it isn't a name.
        aria-label={
          title ||
          (placeholder !== DEFAULT_PLACEHOLDER ? placeholder : undefined) ||
          undefined
        }
        {...props}
      >
        {placeholder ? (
          <option value="" disabled={!value}>
            {placeholder}
          </option>
        ) : null}
        {options.map(({ value, label }) => (
          <option key={value} value={value}>
            {label || value}
          </option>
        ))}
      </select>
    </ResponsiveSelect>
  );
};
